import BackboneViewWrapper from 'utils/backbone/BackboneViewWrapper';

function wrapperViewFactory (backboneView, viewName) {
  return {
    name: `BackboneViewWrapper_${viewName}`,
    extends: BackboneViewWrapper,
    data () {
      return {
        viewFunction: backboneView.default[viewName].bind(backboneView)
      };
    }
  };
}


export default async function wrapBackboneView (controllerImportPromise, viewName) {
  const controller = await controllerImportPromise();
  return wrapperViewFactory(controller, viewName);
}
